import accounts from './accounts';
import bankId from './bankId';
import bankSwap from './bankSwap';
import becomeCustomer from './becomeCustomer';
import cards from './cards';
import components from './components';
import epkFlex from './epkFlex';
import figma from './figma';
import formValidation from './formValidation';
import forms from './forms';
import funds from './funds';
import hunting from './hunting';
import insurance from './insurance';
import loans from './loans';
import overview from './overview';
import paymentAgreements from './paymentAgreements';
import payments from './payments';
import pendingPayments from './pendingPayments';
import pension from './pension';
import property from './property';
import savings from './savings';
import spendings from './spendings';
import transfers from './transfers';

const translationKeys = {
  accounts,
  bankId,
  bankSwap,
  becomeCustomer,
  cards,
  components,
  epkFlex,
  figma,
  formValidation,
  forms,
  funds,
  hunting,
  insurance,
  loans,
  overview,
  paymentAgreements,
  payments,
  pendingPayments,
  pension,
  property,
  savings,
  spendings,
  transfers,
};

Object.freeze(translationKeys);

export default translationKeys;
